import React from 'react';
import QuestionList from '../QuestionList/QuestionList';
import Section, { themes } from '../UI/Section/Section';

const FaqSection = ({ heading, sectionProps, nodes, ...other }) => {
  return !!nodes.length ? (
      <Section
        heading={heading || `Common **questions**`}
        headingProps={{ isCentered: true }}
        {...sectionProps}
        >
        <QuestionList nodes={nodes} {...other} />
      </Section>
  ) : null;
};

export default FaqSection;
